import * as React from 'react';
import * as UI from './style';
import { TooltipPosition, ITooltip } from './TooltipModels';

// tslint:disable-next-line:variable-name
const Tooltip: React.FC<ITooltip> = ({
  dataAt,
  position = TooltipPosition.Center,
  backgroundColor = 'white',
  borderColor = 'white',
  arrow = true,
  style,
  toggler = null,
  height,
  width,
  minHeight,
  minWidth,
  maxHeight,
  maxWidth,
  children,
  contentColor,
  lineHeight,
  boxShadow,
}) => {
  const [tooltipVisible, setTooltipVisible] = React.useState(false);
  const [tooltipHeightElement, setTooltipHeightElement] = React.useState(0);
  const tooltipWrapNode = React.useRef<HTMLElement>(null);

  const tooltipVisibleOff = (e: MouseEvent) => {
    if (tooltipWrapNode && tooltipWrapNode.current && tooltipWrapNode.current.contains(e.target as HTMLElement)) {
      const { height } = tooltipWrapNode.current.getBoundingClientRect();
      setTooltipHeightElement(height);
      return;
    }
    setTooltipVisible(false);
  };

  const toggleTooltipVisible = (event: React.MouseEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.stopPropagation();
    setTooltipVisible(!tooltipVisible);
    return false;
  };

  React.useEffect(() => {
    // add when mounted
    document.addEventListener('mousedown', tooltipVisibleOff); // return function to be called when unmounted
    // remove when unmounted
    return () => {
      document.removeEventListener('mousedown', tooltipVisibleOff);
    };
  }, []);

  return (
    <UI.STooltipWrap ref={tooltipWrapNode} style={style}>
      <UI.STooltipShow onClick={toggleTooltipVisible} toggler={toggler}>
        {toggler}
      </UI.STooltipShow>
      {tooltipVisible && (
        <UI.STooltip
          data-at={dataAt + '-content'}
          maxWidth={maxWidth}
          minHeight={minHeight}
          minWidth={minWidth}
          width={width}
          height={height}
          maxHeight={maxHeight}
          position={position}
          backgroundColor={backgroundColor}
          borderColor={borderColor}
          arrow={arrow}
          tooltipHeight={tooltipHeightElement}
          contentColor={contentColor}
          lineHeight={lineHeight}
          boxShadow={boxShadow}
        >
          {children}
        </UI.STooltip>
      )}
    </UI.STooltipWrap>
  );
};

export default Tooltip;
